import { IMAGES } from "@/config/site";

// Flexible service directory. Prices/durations/add-ons/availability are
// intentionally left as placeholders and confirmed through Vagaro.
export const SERVICES = [
  {
    id: "in-suite-massage",
    bookingType: "individual",
    name: "In-Suite Massage",
    description:
      "Professional massage services at the Legacy Spa suite in North Houston.",
    duration: "Confirmed through Vagaro",
    price: "Confirmed through Vagaro",
    locationType: "In-Suite",
    addOns: "Confirmed through Vagaro",
    availability: "Confirmed through Vagaro",
    image: IMAGES.inSuite,
    imageAlt:
      "Calm, clean massage treatment room prepared for an in-suite session.",
    status: "Bookable",
    bookable: true,
  },
  {
    id: "mobile-massage",
    bookingType: "individual",
    name: "Mobile Massage",
    description:
      "Massage services delivered to eligible homes, businesses and approved locations in Greater Houston.",
    duration: "Confirmed through Vagaro",
    price: "Confirmed through Vagaro",
    locationType: "Mobile",
    addOns: "Confirmed through Vagaro",
    availability: "Confirmed through Vagaro",
    image: IMAGES.therapistHands,
    imageAlt:
      "Massage therapist's hands working along a client's shoulders and back.",
    status: "Bookable",
    bookable: true,
  },
  {
    id: "corporate-chair-massage",
    bookingType: "corporate",
    name: "Corporate Chair Massage",
    description:
      "On-site chair massage for employee-wellness programs, appreciation events and workplace activations.",
    duration: "Confirmed through Vagaro",
    price: "Confirmed through Vagaro",
    locationType: "Corporate / On-site",
    addOns: "Confirmed through Vagaro",
    availability: "Confirmed through Vagaro",
    image: IMAGES.corporateChair,
    imageAlt:
      "Seated chair massage being provided to an employee in an office setting.",
    status: "Bookable",
    bookable: true,
  },
  {
    id: "corporate-table-massage",
    bookingType: "corporate",
    name: "Corporate Table Massage",
    description:
      "On-site table massage for employee-wellness programs and recurring workplace service.",
    duration: "Confirmed through Vagaro",
    price: "Confirmed through Vagaro",
    locationType: "Corporate / On-site",
    addOns: "Confirmed through Vagaro",
    availability: "Confirmed through Vagaro",
    image: IMAGES.massageRoom,
    imageAlt: "Professional massage table set up for an on-site session.",
    status: "Bookable",
    bookable: true,
  },
  {
    id: "corporate-wellness-programs",
    bookingType: "corporate",
    name: "Corporate Wellness Programs",
    description:
      "One-time events and recurring workplace-wellness programs tailored to your organization.",
    duration: "Confirmed through Vagaro",
    price: "Confirmed through Vagaro",
    locationType: "Corporate / On-site",
    addOns: "Confirmed through Vagaro",
    availability: "Confirmed through Vagaro",
    image: IMAGES.office,
    imageAlt: "Modern corporate office where wellness programs are delivered.",
    status: "Bookable",
    bookable: true,
  },
];

// Corporate wellness program offerings for the B2B page.
export const CORPORATE_PROGRAMS = [
  {
    id: "employee-wellness",
    title: "Employee Wellness",
    description:
      "On-site chair and table massage integrated into your team's wellbeing routine.",
  },
  {
    id: "appreciation-events",
    title: "Appreciation Events",
    description:
      "Show gratitude with a memorable massage experience at company events.",
  },
  {
    id: "recurring-programs",
    title: "Recurring Programs",
    description:
      "Regularly scheduled on-site sessions that make wellness a workplace habit.",
  },
  {
    id: "health-fairs",
    title: "Health Fairs",
    description:
      "A calming, high-engagement station for your health and wellness fairs.",
  },
  {
    id: "workplace-activations",
    title: "Workplace Activations",
    description:
      "Brand and culture activations featuring restorative massage moments.",
  },
];

export const CORPORATE_INDUSTRIES = [
  "Manufacturing",
  "Healthcare",
  "Oil & Gas",
  "Aviation",
  "Large Employers & Corporate Offices",
];
